
export const downloadFile = (data, contentType, filename) => {
  const blob = new Blob([data], { type: contentType });
  let link = document.createElement("a");
  if (link.download !== undefined) {
    // Only Browsers that support the HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const downloadCsvFile = (data, filename) => {
  const link = document.createElement('a');
  link.href = `data:text/csv;base64,${data}`;
  link.download = filename;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadExcelFile = (data, filename) => {
  const link = document.createElement('a');
  link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${data}`;
  link.download = filename;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadTxtFile = (data, filename) => {
  const link = document.createElement('a');
  link.href = `data:text/csv;base64,${data}`;
  link.download = filename;
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};